import { Button, Icon, Typography } from "@mui/material";
import { calculateHeight, calculatePositionTop } from "./CalendarItemUtils";

export function formatDateTimeToHumanReadable(date) {
  return new Date(date).toLocaleString()
}

export function ScheduleCalendarItem({ onClick, onArrivedClick, onModifyClick, topPositionBias, schedule, calculateLeftPosition, minuteHeight, itemWidth }) {
  const simpleCardLeftPosition = calculateLeftPosition();
  function cardColor() {
    return schedule.status === 'arrived_on_time' ? 'green'
      : schedule.status === 'arrived_late' ? 'red'
        : '#3f51b5';
  }

  return (
    <div key={schedule.id}
      onClick={() => onClick()}
      style={{
        zIndex: 100,
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'space-between',
        cursor: 'pointer',
        top: calculatePositionTop(topPositionBias, schedule.starting_date, minuteHeight),
        left: simpleCardLeftPosition,
        border: '1px solid #ccc',
        position: 'absolute',
        width: itemWidth,
        padding: '10px',
        height: calculateHeight(schedule.starting_date, schedule.ending_date, minuteHeight),
        backgroundColor: cardColor(),
        borderRadius: '8px',
        boxShadow: '0 0 10px #0006',
      }}
    >
      <div>
        <div style={{ display: 'flex' }} >
          <Typography variant="h5">{schedule.client.name}</Typography>
          <Icon style={{

            display: schedule.client.other ? 'block' : 'none',
            marginLeft: 8,
            fontSize: 18
          }}>comment</Icon>
        </div>
        <Typography style={{ display: 'none' }}>{schedule.client.other}</Typography>
        <Typography style={{ display: 'none' }}>Tel: {schedule.client.contact_details?.value}</Typography>

        <div style={{
          display: 'none',
          flexDirection: 'column'
        }}>
          <Typography variant="h6">Servicios</Typography>
          {schedule.services?.map(service => <Typography key={service.id}>{service.displayable_name}</Typography>)}
        </div>
        <div style={{ display: 'flex' }}>
          {schedule.services?.map(service => service.displayable_name).join(', ')}
        </div>
      </div >
      <div style={{
        marginTop: 8,
        display: 'none',
        justifyContent: 'end'
      }}>
        <Button
          variant='contained'
          onClick={() => onModifyClick()}
        >Modificar Turno</Button>
        <Button
          style={{ marginLeft: 8 }}
          variant='contained'
          onClick={() => onArrivedClick()}
        >Llegó</Button>
      </div>
    </div >
  );
}
